// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2H6yy","content":"GlobalSearch_content__3sgdf"};